module.exports = __webpack_public_path__ + "images/guide.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide.png
// module id = 431
// module chunks = 17